import React from 'react'

import ReactDOM from 'react-dom/client'

import './index.css'
import { Home } from './screens/Home/Home'
import { LandingPage } from './screens/LandingPage/LandingPage'

ReactDOM.createRoot(document.getElementById('root') as Element).render(
    <React.StrictMode>
        <Home />
        <LandingPage />
    </React.StrictMode>
)
